import { Entity } from "../helpers/Entity"
import { PricingRowDto } from "./PricingRow"
import { PricingTotalDto } from "./PricingTotals"

export type PricingTableDto = {
    id: string
    type: string
    rows: PricingRowDto[]
    totals: PricingTotalDto[]
    objectId: string
    objectType: string
}

export default class PricingTable implements Entity {
    private dto: PricingTableDto

    constructor(dto: PricingTableDto) {
        this.dto = dto
    }

    isLoaded() {
        return this.dto.id != "" && this.dto.type == "pricing-table"
    }

    getId() {
        return this.dto.id
    }

    getItems() {
        return this.dto.rows
    }

    getObjectId() {
        return this.dto.objectId
    }

    getObjectType() {
        return this.dto.objectType
    }

    getDto() {
        return this.dto
    }

}



// WEBPACK FOOTER //
// ./src/state/pricing/PricingTable.ts